// Baseline "System" tier — rules that are always active regardless of any
// Staff/StaffGroup assignment. PCI's equivalent lives inside the compiled
// SecurityInterface COM object, so it isn't available to port line-for-line;
// this starts empty and is meant to be filled in as System-level defaults are
// identified. Entries use the same shape as a securityRulesFunctionality row,
// e.g. { entityType: "Module", moduleId: 1, allowSetting: "1023", denySetting: "0", ruleActive: true }.
export const SYSTEM_SECURITY_DEFAULTS = [];
